module.exports = __webpack_public_path__ + "static/media/table-a.2f5d9719.png";